import { apiClient } from '@app/api';
import { AuditAudio } from '@mi-front/core';
import { useQuery } from '@tanstack/react-query';

/**
 * Loads the creative/script transcription for an audit audio.
 * Uses the preloaded value when available; otherwise fetches from the audios list API.
 */
export function useAuditAudioTranscription(
  stationId: string,
  customId: string | undefined,
  alreadyLoaded: AuditAudio['transcription'] | undefined,
  enabled: boolean,
) {
  return useQuery({
    queryKey: ['audit-audio-transcription', stationId, customId],
    queryFn: async (): Promise<AuditAudio['transcription'] | null> => {
      if (!customId) {
        return null;
      }

      const { results } = await apiClient.audit.fetchAudios({
        stationId,
        filter: { customId },
        pageSize: 1,
      });

      return results[0]?.transcription ?? null;
    },
    enabled: enabled && !!customId && !alreadyLoaded?.content,
    initialData: alreadyLoaded?.content ? alreadyLoaded : undefined,
    staleTime: 5 * 60 * 1000,
  });
}
